<template>
    <div >
        <div class="row">
            <div class="col-xs-12">
                <div class="alert alert-success alert-dismissible" role="alert" v-if="isSave">
                    <button type="button" class="close" aria-label="Close"  @click="isSave = false"><span aria-hidden="true">&times;</span></button>
                    <strong>Success!</strong> Broadcast "{{name}}" save draft
                </div>
                <div class="alert alert-danger alert-dismissible" role="alert" v-if="isFail">
                    <button type="button" class="close" aria-label="Close"  @click="isFail = false"><span aria-hidden="true">&times;</span></button>
                    <strong>Oop!</strong> Broadcast "{{name}}" save draft fail
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-6"><h3 class="title">Broadcast Detail</h3></div>
            <div class="col-sm-6 text-right" >
                <a href="javascript:void(0);" class="btn btn-default" style="margin-bottom: 15px;" @click="onBack"><i class="fas fa-chevron-left"></i> Back</a>
                <a href="javascript:void(0);" class="btn btn-default" style="margin-bottom: 15px;" @click="onSave"><i class="fas fa-save"></i> Save Draft</a>
                <a href="javascript:void(0);" class="btn btn-primary" style="margin-bottom: 15px;" @click="onSend"><i class="fas fa-paper-plane"></i> Send</a>
            </div>
        </div>
        <div style="border: 1px solid #eee; border-radius: 10px" v-if="broadcast">
            <div class="container-fluid">
                <div class="row" style="margin-top: 30px">
                    <div class="col-sm-3">Broadcast Name</div>
                    <div class="col-sm-4" :class="{'has-error': errors.has('broadcastName')}">
                        <input type="text" class="form-control" name="broadcastName" data-vv-name="broadcastName" data-vv-as="Broadcast Name" placeholder="Broadcast Name" v-validate="'required'" v-model="name">
                        <p class="text-error" v-show="errors.has('broadcastName')">{{ errors.first('broadcastName') }}</p>
                    </div>
                </div>

                <div class="row">
                    <hr>
                </div>

                <div class="row">
                    <div class="col-sm-3">Message Type</div>
                    <div class="col-sm-2">
                        <input type="radio" name="radio_message_type" value="promotion" v-model="sendtype"> Promotion
                        
                    </div>
                    <div class="col-sm-2">

                        <input type="radio" name="radio_message_type" value="subscription" v-model="sendtype"> Subscription
                    </div>
                </div>

                <div class="row" v-if="sendtype == 'subscription'">
                    <div class="col-sm-9 col-sm-offset-3" style="margin-top: 15px;">
                        <div class="alert alert-warning" role="alert">Before using this feature, please apply Facebook Page Subscription Messages. <a href="https://developers.facebook.com/docs/messenger-platform/policy/app-to-page-subscriptions/" target="_blank" rel="noopener noreferrer">See How do I apply to send subscription messages?</a>
                        You cannot broadcast promotional message. Your page might be blocked by Facebook if you broadcast promotional messages or when user report that they receive too many messages. <a href="https://developers.facebook.com/docs/messenger-platform/policy/policy-overview/#subscription_messaging" target="_blank" rel="noopener noreferrer">See guideline for more information</a></div>
                    </div>
                </div>

                <div class="row" v-else>
                    <div class="col-sm-9 col-sm-offset-3" style="margin-top: 15px;">
                        <div class="alert alert-warning" role="alert">Promotion message can only reach user who had conversation with chatbot within last 24 hours.</div>
                    </div>
                </div>


                <div class="row">
                    <hr>
                </div>

                <div class="row">
                    <div class="col-sm-3">Notification Setting</div>
                    <div class="col-sm-2">
                        <input type="radio" name="radio_notification_setting" value="SILENT_PUSH" v-model="pushtype"> Silent Push <span style="color:#d4d4d4" v-tooltip.top="'Silent Push notification will display a phone notification without sound. Use it for regular messages that don\'t require immediate action.'"><i class="fas fa-info-circle"></i></span>
                        
                    </div>
                    <div class="col-sm-2">

                        <input type="radio" name="radio_notification_setting" value="REGULAR" v-model="pushtype"> Regular Push <span style="color:#d4d4d4" v-tooltip.top="'Regular Push notification will make a sound and display a phone notification. Use it for important messages.'"><i class="fas fa-info-circle"></i></span>
                    </div>
                    <div class="col-sm-2">
                        <input type="radio" name="radio_notification_setting" value="NO_PUSH" v-model="pushtype"> No Push <span style="color:#d4d4d4" v-tooltip.top="'Silent Push notification will display a phone notification without sound. Use it for regular messages that don\'t require immediate action.'"><i class="fas fa-info-circle"></i></span>
                    </div>
                    
                </div>
                
                <div class="row">
                    <hr>
                </div>

                <div class="row">
                    <div class="col-sm-3">Target</div>
                    <div class="col-sm-4">
                        <template v-if="loadingEstimate">
                            <sync-loader :color="$store.state.theme.brand_color" :size="'8px'" style="display:inline-block;margin-bottom: 10px"></sync-loader> 
                        </template>
                        <template v-else>
                            <p>Approximate <tween-num :value="parseInt(estimate_user)" :initial="0" :formatter="numberFormat"></tween-num> users</p>
                        </template>
                        <select name="broadcastGroupType" id="broadcastGroupType" class="form-control" v-model="groupType" style="margin-bottom: 5px;">
                            <option value="">All</option>
                             <!-- <option value="subscribe">Subscribe</option> 
                            <option value="subscribebroadcast">Subscribe Broadcast</option>  -->
                            <option value="male">Male</option>
                            <option value="female">Female</option>
                            <option value="customize">Customize</option>
                        </select>
                        <template v-if="false">
                        <cool-select :items="groupTypeOptions" v-model="groupType" item-value="value" item-text="label" :disableSearch="true" @select="onSelectGroupType">
                            <template slot="item" slot-scope="{ item: type }">
                                
                                {{ type.label }} <template v-if="type.value == 'customize'"><v-premium-lock :inline="true"></v-premium-lock></template>
                                
                            </template>
                            <template slot="selection" slot-scope="{ item: type }">
                                {{ type.label }} <template v-if="type.value == 'customize'"><v-premium-lock :inline="true"></v-premium-lock></template>
                            </template>
                        </cool-select>
                        </template>
                        <!-- <a href="javascipt:void(0)" class="btn btn-primary transparent" @click="showAdvance = !showAdvance">Show Filter <i class="fas fa-angle-down" v-if="!showAdvance"></i> <i class="fas fa-angle-up" v-else></i></a></div>                 -->
                    </div>
                </div>

                <div class="row" v-if="groupType == 'customize'">
                    <div class="col-xs-12">
                        <template v-if="$store.getters.getPackage == 'premium'">
                            <div  style="border: 1px solid #eee;padding: 5px 10px 0px 10px;border-radius: 10px;margin-top: 15px;background: #fbfbfb">
                                <div class="row">
                                    <div class="col-sm-4" style="margin-bottom: 10px">
                                        <label for="">Name</label>
                                        <input type="text" placeholder="Name" v-model="filter.fullname" class="form-control" maxlength="255">
                                    </div>
                                    <div class="col-sm-2" style="margin-bottom: 10px">
                                        <label for="">Channel</label>
                                        <select name="filter" class="form-control" v-model="filter.app">
                                            <option value="all">All</option>
                                            <option value="facebook">Facebook</option>
                                            <option value="line">Line</option>
                                        </select>
                                    </div>
                                    <div class="col-sm-2" style="margin-bottom: 10px">
                                        <label for="">Gender</label>
                                        <select name="filter" class="form-control" v-model="filter.gender">
                                            <option value="all">All</option>
                                            <option value="male">Male</option>
                                            <option value="female">Female</option>
                                            <option value="other">No gender</option>
                                        </select>
                                    </div>
                                    <div class="col-sm-4" style="margin-bottom: 10px">
                                        <label for="">Locale</label>
                                        <v-select :options="localeOptions" label="title" v-model="filter.locale" placeholder="Locale" multiple>
                                            <template slot="option" slot-scope="option">
                                                <flag :iso="option.icon" />
                                                {{ option.title }}
                                            </template>
                                        </v-select>
                                    </div>
                                    <div class="clearfix"></div>
                                    <div class="col-sm-6" style="margin-bottom: 10px">
                                        <div>
                                            <label for="">First Conversation At</label>
                                        </div>
                                        <template>
                                            <span class="dashboard_datepicker"> <datepicker v-model="filter.registerDate.start" style="margin-bottom: 10px;" @selected="onRegisterStartDate" placeholder="From" :clear-button="true" :clear-button-icon="'fas fa-times'"></datepicker></span>
                                            <span class="hidden-xs" style="margin: 0 10px"> - </span>
                                            <span class="dashboard_datepicker" style="margin-bottom: 10px;"><datepicker v-model="filter.registerDate.end" style="" @selected="onRegisterEndDate"  placeholder="To" :clear-button="true" :clear-button-icon="'fas fa-times'"></datepicker></span>
                                            <span class="hidden-xs" style="margin-right: 10px;"></span>
                                            <div class="hidden-sm hidden-md hidden-lg"></div>
                                        </template>
                                    </div>

                                    <div class="col-sm-6" style="margin-bottom: 10px">
                                        <div>
                                            <label for="">Last Conversation At</label>
                                        </div>
                                        <template>
                                            <span class="dashboard_datepicker"> <datepicker v-model="filter.activeDate.start" style="margin-bottom: 10px;" @selected="onActiveStartDate" placeholder="From" :clear-button="true" :clear-button-icon="'fas fa-times'"></datepicker></span>
                                            <span class="hidden-xs" style="margin: 0 10px"> - </span>
                                            <span class="dashboard_datepicker" style="margin-bottom: 10px;"> <datepicker v-model="filter.activeDate.end" style="" @selected="onActiveEndDate" placeholder="To" :clear-button="true" :clear-button-icon="'fas fa-times'"></datepicker></span>
                                            <span class="hidden-xs" style="margin-right: 10px;"></span>
                                            <div class=" hidden-md hidden-lg"></div>
                                        </template>
                                    </div>
                                    <div class="clearfix"></div>
                                    <div class="col-sm-4" style="margin-bottom: 10px">
                                        <label for="">Email</label>
                                        <input type="text" placeholder="Email" v-model="filter.email" class="form-control" maxlength="255">
                                    </div>
                                    <div class="col-sm-4" style="margin-bottom: 10px">
                                        <label for="">Phone No</label>
                                        <input type="text" placeholder="Phone No" v-model="filter.phoneno" class="form-control" maxlength="255">
                                    </div>
                                    <div class="col-sm-4" style="margin-bottom: 10px">
                                        <label for="">Message Sent</label>
                                        <div class="form-inline" :class="{'has-error': errors.has('filterMessageSentFrom') || errors.has('filterMessageSent')}">
                                            <select name="" id="" v-model="filter.messagesent.symbol" class="form-control">
                                                <option value="g__">Greater than</option>
                                                <option value="l__">Less than</option>
                                                <option value="n__">Not</option>
                                            </select>
                                            <input type="text" class="form-control" name="filterMessageSent" data-vv-name="filterMessageSent" data-vv-as="Message Sent" placeholder="Value" style="max-width: 150px" v-model="filter.messagesent.value" v-validate="'numeric'">
                                            <!-- <input type="text" class="form-control" name="filterMessageSentFrom" data-vv-name="filterMessageSentFrom" data-vv-as="Message Sent From" placeholder="From" style="max-width: 150px" v-model="filter.messagesent.from" v-validate="'numeric'">
                                            -
                                            <input type="text" class="form-control" name="filterMessageSentTo" data-vv-name="filterMessageSentTo" data-vv-as="Message Sent To" placeholder="To" style="max-width: 150px" v-model="filter.messagesent.to" v-validate="'numeric'"> -->
                                            <p class="text-error" v-if="errors.has('filterMessageSentFrom')">{{ errors.first('filterMessageSentFrom') }}</p>
                                            <p class="text-error" v-else-if="errors.has('filterMessageSent')">{{ errors.first('filterMessageSent') }}</p>
                                        </div>
                                    </div>
                                    <div class="col-sm-4" style="margin-bottom: 10px">
                                        <label for="">Status</label>
                                        <input type="text" class="form-control" placeholder="Status" v-model="filter.status" maxlength="255">
                                    </div>
                                    <div class="col-sm-4" style="margin-bottom: 10px">
                                        <label for="">Intent</label>
                                        <v-select :options="filterIntent" label="title" v-model="filter.intent" placeholder="Intent" multiple></v-select>
                                    </div>
                                    

                                </div>
                            </div>
                        </template>
                        <template v-else-if="$store.getters.getPackage == 'normal'">
                            <div style="position: relative">
                                <v-premium-plan-popup :showAll="false" marginTop="65"></v-premium-plan-popup>
                                <div  style="border: 1px solid #eee;padding: 5px 10px 0px 10px;border-radius: 10px;margin-top: 15px;background: #fbfbfb">
                                    <div class="row">
                                        <div class="col-sm-4" style="margin-bottom: 10px">
                                            <label for="">Name</label>
                                            <input type="text" placeholder="Name" class="form-control" maxlength="255">
                                        </div>
                                        <div class="col-sm-4" style="margin-bottom: 10px">
                                            <label for="">Channel</label>
                                            <select name="filter" class="form-control">
                                                <option value="all">All</option>
                                                <option value="facebook">Facebook</option>
                                                <option value="line">Line</option>
                                            </select>
                                        </div>
                                        <div class="col-sm-4" style="margin-bottom: 10px">
                                            <label for="">Gender</label>
                                            <select name="filter" class="form-control">
                                                <option value="all">All</option>
                                                <option value="male">Male</option>
                                                <option value="female">Female</option>
                                                <option value="other">No gender</option>
                                            </select>
                                        </div>
                                        <div class="col-sm-4" style="margin-bottom: 10px">
                                            <label for="">Email</label>
                                            <input type="text" placeholder="Email" class="form-control" maxlength="255">
                                        </div>
                                        <div class="col-sm-4" style="margin-bottom: 10px">
                                            <label for="">Phone No</label>
                                            <input type="text" placeholder="Phone No" class="form-control" maxlength="255">
                                        </div>
                                        <div class="col-sm-4" style="margin-bottom: 10px">
                                            <label for="">Message Sent</label>
                                            <div class="form-inline" :class="{'has-error': errors.has('filterMessageSentFrom') || errors.has('filterMessageSent')}">
                                                <select name="" id=""  class="form-control">
                                                    <option value="g__" selected>Greater than</option>
                                                    <option value="l__">Less than</option>
                                                    <option value="n__">Not</option>
                                                </select>
                                                <input type="text" class="form-control" name="filterMessageSent" data-vv-name="filterMessageSent" data-vv-as="Message Sent" placeholder="Value" style="max-width: 150px" v-validate="'numeric'">
                                                <!-- <input type="text" class="form-control" name="filterMessageSentFrom" data-vv-name="filterMessageSentFrom" data-vv-as="Message Sent From" placeholder="From" style="max-width: 150px" v-model="filter.messagesent.from" v-validate="'numeric'">
                                                -
                                                <input type="text" class="form-control" name="filterMessageSentTo" data-vv-name="filterMessageSentTo" data-vv-as="Message Sent To" placeholder="To" style="max-width: 150px" v-model="filter.messagesent.to" v-validate="'numeric'"> -->
                                                <p class="text-error" v-if="errors.has('filterMessageSentFrom')">{{ errors.first('filterMessageSentFrom') }}</p>
                                                <p class="text-error" v-else-if="errors.has('filterMessageSent')">{{ errors.first('filterMessageSent') }}</p>
                                            </div>
                                        </div>
                                        <div class="col-sm-4" style="margin-bottom: 10px">
                                            <label for="">Status</label>
                                            <input type="text" class="form-control" placeholder="Status"  maxlength="255">
                                        </div>
                                        <div class="col-sm-4" style="margin-bottom: 10px">
                                            <label for="">Locale</label>
                                            <v-select :options="localeOptions" label="title" placeholder="Locale" multiple>
                                                <template slot="option" slot-scope="option">
                                                    <flag :iso="option.icon" />
                                                    {{ option.title }}
                                                </template>
                                            </v-select>
                                        </div>
                                        <div class="col-sm-4" style="margin-bottom: 10px">
                                            <label for="">Intent</label>
                                            <v-select :options="filterIntent" label="title"  placeholder="Intent" multiple></v-select>
                                        </div>
                                        
                                        <div class="clearfix"></div>
                                        <div class="col-sm-6" style="margin-bottom: 10px">
                                            <div>
                                                <label for="">First Conversation At</label>
                                            </div>
                                            <template>
                                                <span class="dashboard_datepicker"> <datepicker  style="margin-bottom: 10px;"  placeholder="From" :clear-button="true" :clear-button-icon="'fas fa-times'"></datepicker></span>
                                                <span class="hidden-xs" style="margin: 0 10px"> - </span>
                                                <span class="dashboard_datepicker" style="margin-bottom: 10px;"><datepicker  style=""   placeholder="To" :clear-button="true" :clear-button-icon="'fas fa-times'"></datepicker></span>
                                                <span class="hidden-xs" style="margin-right: 10px;"></span>
                                                <div class="hidden-sm hidden-md hidden-lg"></div>
                                            </template>
                                        </div>

                                        <div class="col-sm-6" style="margin-bottom: 10px">
                                            <div>
                                                <label for="">Last Conversation At</label>
                                            </div>
                                            <template>
                                                <span class="dashboard_datepicker"> <datepicker style="margin-bottom: 10px;" placeholder="From" :clear-button="true" :clear-button-icon="'fas fa-times'"></datepicker></span>
                                                <span class="hidden-xs" style="margin: 0 10px"> - </span>
                                                <span class="dashboard_datepicker" style="margin-bottom: 10px;"> <datepicker  placeholder="To" :clear-button="true" :clear-button-icon="'fas fa-times'"></datepicker></span>
                                                <span class="hidden-xs" style="margin-right: 10px;"></span>
                                                <div class=" hidden-md hidden-lg"></div>
                                            </template>
                                        </div>

                                    </div>
                                </div>
                            </div>                  
                        </template>
                    </div>
                </div>

                <div class="row">
                    <hr>
                </div>

                <div class="row">
                    <div class="col-xs-12">
                        <div class="row">

                            <div class="col-xs-12 col-sm-12" style="margin-bottom:10px">
                                <a href="javascript:void(0);" v-for="(option) in typeOptions" :key="'option_'+option.value" class="btn btn-none-radius" :class="{'btn-default': type != option.value, 'btn-primary': type == option.value}" @click="onOptionChange(option.value)" style="margin-right:5px;margin-bottom:5px;">{{option.name}}</a>
                            </div>
                        </div>
                        <template v-if="type == 'text'">
                            <div>
                                <intent-group v-model="message" :hasAlternative="false"></intent-group>
                            </div>
                            <div class="clearfix"></div>
                        </template>
                        <template v-else-if="type == 'template'">
                            <div style="overflow-x:scroll;margin-bottom:5px;">
                                <div style="margin:0;overflow:auto;" :style="{'width': ((generics.length * 315) + (generics.length < 10 ? 315 : 0)) +'px'}">
                                    <div style="float:left;width:300px;margin-right: 15px;" v-for="(generic,index) in generics" :key="'generic_'+index">
                                        <generic-manage :vkey="index" v-model="generics[index]" @onDelete="onDeleteGeneric(index)" :isValidate="true">
                                            <move-horizontal slot="move" :index="index" :max="generics.length" @onMove="onMove(index,$event)"></move-horizontal>
                                        </generic-manage>

                                    </div>
                                    <div v-if="generics.length < 10" @click="addGeneric" style="position:relative;float:left;width:300px;border: 4px dashed #eee;border-radius: 20px;height: 300px;cursor:pointer">
                                        <div style="position:absolute;left: 50%;top: 50%;margin-left: -10px;margin-top: -23px;font-size: 32px;">
                                            <span class="glyphicon glyphicon-plus"></span>
                                        </div>
                                    </div>
                                </div>
                                <div class="clearfix"></div>
                            </div>
                        </template>
                        <br>
                    </div>
                </div>
            </div>
            <hr>
            <div class="text-center">
                <a href="javascript:void(0);" class="btn btn-default" style="margin-bottom: 15px;" @click="onBack"><i class="fas fa-chevron-left"></i> Back</a>
                <a href="javascript:void(0);" class="btn btn-default" style="margin-bottom: 15px;" @click="onSave"><i class="fas fa-save"></i> Save Draft</a>
                <a href="javascript:void(0);" class="btn btn-primary" style="margin-bottom: 15px;" @click="onSend"><i class="fas fa-paper-plane"></i> Send</a>
            </div>
        </div>
        <modal-dialog2 v-if="showUpgrade" @close="showUpgrade = false">
            <div slot="body" style="overflow: auto">
                <div style="position: relative">
                    <v-premium-plan-popup :inline="true" backgroundColor="white"></v-premium-plan-popup>
                </div>
                
            </div>

            <div slot="footer">
                <div class="text-center">
                    <button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal" @click="showUpgrade = false">Close</button>
                </div>
            </div>
        </modal-dialog2>
    </div>
</template>
<script>
import api from '@/api'
import SyncLoader from 'vue-spinner/src/SyncLoader.vue'
import numeral from 'numeral'
import { mapGetters, mapMutations } from 'vuex'
import moment from "moment";
import config from '@/config'
import datepicker from "vuejs-datepicker";
import IntentGroup from '@/components/view/intent/IntentGroup'
import GenericManage from '@/components/elements/GenericManage'
import MoveHorizontal from '@/components/elements/MoveHorizontal'
import TweenNum from "vue-tween-number";
import ModalDialog2 from "@/components/elements/ModalDialog2";
// import { constants } from 'http2';
import { CoolSelect } from 'vue-cool-select'

    export default {
        props: ['value'],
        
        data: function(){
            return {
                showUpgrade: false,
                broadcast: undefined,
                isSave: false,
                isFail: false,
                name: '',
                localeOptions: config.locale,
                groupTypeOptions: [
                    {
                        label: 'All',
                        value: ''
                    },
                    {
                        label: 'Male',
                        value: 'male'
                    },
                    {
                        label: 'Female',
                        value: 'female'
                    },
                    {
                        label: 'Customize',
                        value: 'customize'
                    }
                ],
                intents: [],
                type: 'text',
                groupType: '',
                sendtype: 'promotion',
                pushtype: 'SILENT_PUSH', //REGULAR/SILENT_PUSH/NO_PUSH 
                message: '',
                quick_reply: '',
                typeOptions: [
                    {
                        'value' : 'text',
                        'name' : 'Text'
                    },
                    {
                        'value' : 'template',
                        'name' : 'Generic' 
                    }
                ],
                generics: [
                    {
                        image_url: null,
                        title: '',
                        subtitle: '',
                        buttons: [],

                        enable: true
                    },
                ],
                filter: {
                    fullname: "",
                    gender: 'all',
                    locale: null,
                    app: 'all',
                    intent: null,
                    email: "",
                    phoneno: "",
                    messagesent: {
                        value: null,
                        symbol: 'g__',
                    },
                    timezone: {
                        from: -12,
                        to: 14,
                    },
                    activeDate: {
                        enable: false,
                        start: null,
                        end: null
                    },
                    registerDate: {
                        enable: false,
                        start: null,
                        end: null
                    }
                },
                estimate_user: 0,
                loadingEstimate: true
            }
        },
        components: {
            datepicker,
            IntentGroup,
            GenericManage,
            MoveHorizontal,
            TweenNum,
            SyncLoader,
            CoolSelect,
            ModalDialog2
        },
        mounted: function(){
            var vm = this
            vm.getIntent(function(){
                
            })

            if (vm.value) {
                vm.broadcast = Object.assign({},vm.value)
                vm.cached_broadcast = Object.assign({},vm.value)    

                var filters = vm.broadcast.m_condition.split('&')
                // console.log(filters) 
                if (filters.length > 0) { 
                    if (filters.length > 1) {
                        vm.groupType = 'customize'
                    } else {
                        var value = filters[0].split(/=(.+)/)
                        if (value.length > 1 && value[0] == 'gender') {
                            
                            vm.groupType = value[1]
                        }
                        
                    } 
                    $.each(filters,function(index, filter){
                        var value = filter.split(/=(.+)/)
                        if (value.length > 1) {
                            // console.log(v/alue)
                            switch (value[0]) {
                                case 'fullname':
                                case 'gender':
                                case 'app':
                                case 'email':
                                case 'status':
                                case 'phoneno':
                                    vm.filter[value[0]] = value[1]
                                    break;
                                case 'messagesent':
                                    var messagesent = value[1].split('__')
                                    vm.filter[value[0]] = {
                                        value : messagesent[1],
                                        symbol : messagesent[0] + '__'
                                    }
                                    break;
                                case 'locale':
                                    var locales = value[1].split(',')
                                    vm.filter.locale = []
                                    $.each(locales,function(lindex, locale){
                                        $.each(vm.localeOptions,function(clindex, config_local){
                                            if (config_local.value == locale) {
                                                vm.filter.locale.push(config_local)
                                                return false
                                            }
                                        })
                                    })
                                    break;
                                case 'intent':
                                    vm.filter.intent = value[1].split(',')
                                    break;
                                case 'timestamp_from': 
                                    vm.filter.activeDate.start = moment(value[1]).toDate()
                                    break;
                                case 'timestamp_to': 
                                    vm.filter.activeDate.end = moment(value[1]).toDate()
                                    break;
                                case 'registertimestamp_from': 
                                    vm.filter.registerDate.start = moment(value[1]).toDate()
                                    break;
                                case 'registertimestamp_to': 
                                    vm.filter.registerDate.end = moment(value[1]).toDate()
                                    break;
                            }
                        }
                    })
                }

                vm.name = vm.broadcast.name
                vm.type = vm.broadcast.m_type
                vm.quick_reply = vm.broadcast.m_quick_reply
                vm.sendtype = vm.broadcast.sendtype ? vm.broadcast.sendtype : 'promotion'
                vm.pushtype = vm.broadcast.pushtype ? vm.broadcast.pushtype : 'SILENT_PUSH'

                if(vm.type == 'template'){
                    vm.generics = JSON.parse(vm.broadcast.m_val)
                }  else {
                    vm.message = vm.broadcast.m_val
                }
                
            } else {
                vm.broadcast = {
                    m_condition: null,
                    name: null,
                    m_type: null,
                    m_quick_reply: null,
                    m_val: null,
                }
            }


            if (vm.name == '') {
                vm.name = 'Broadcast_'+ moment().format('YYYY_MM_DD_HH_mm')
            }

            vm.$nextTick(function(){
                if (vm.groupType == 'customize') {
                    if (vm.$store.getters.getPackage == 'premium') {                        
                        vm.estimateReach(vm.groupType)      
                    } else {
                        vm.estimateReach('')   
                    }
                } else {
                    vm.estimateReach(vm.groupType)
                }
            })

        },
        computed: {
            ...mapGetters({
                selectedBot: 'selectedBot',
            }),
            filterIntent: function(){
                var vm = this
                vm.intents.sort(function(a, b) {
                    var nameA = a.intentname.toUpperCase(); // ignore upper and lowercase
                    var nameB = b.intentname.toUpperCase(); // ignore upper and lowercase
                    if (a.intentname[0] == '{' && a.intentname[a.intentname.length - 1] == '}') {
                        return 1;
                    }
                    if (b.intentname[0] == '{' && b.intentname[b.intentname.length - 1] == '}') {
                        return -1;
                    }
                    if (nameA < nameB) {
                        return -1;
                    }
                    if (nameA > nameB) {
                        return 1;
                    }

                    // names must be equal
                    return 0;
                });
                var intents = []
                $.each(vm.intents ,function(index, intent){
                    intents.push(intent.intentname)
                })
                return intents
            }
        },
        methods: {
            numberFormat: function(val){
                return numeral(val).format('0,0')
            },
            getIntent: function(callback) {
                let vm = this
                let auth = null;
                let data = {
                    pageid : vm.selectedBot.pageid,
                }
                api.getIntent(data,function(error, response){
                    if (error) {
                        console.error(error)
                        return
                    }
                    if (response.data) {
                        var isFoundDefault = false
                        $.each(response.data,function(index, val){
                            var intent = val
                            intent.isShow = false
                            vm.intents.push(intent)
                        })
                    }
                    callback()
                })
            },
            onActiveStartDate: function(value){
			
                var vm = this
                if (moment(this.filter.activeDate.end).isBefore(value)) {
                    this.filter.activeDate.end = value
                }
                this.filter.activeDate.start = value
            },
            onActiveEndDate: function(value){
                var vm = this
                if (moment(value).isBefore(this.filter.activeDate.start)) {
                    this.filter.activeDate.start = value
                }
                this.filter.activeDate.end = value
            },
            onRegisterStartDate: function(value){
                
                var vm = this
                if (moment(this.filter.registerDate.end).isBefore(value)) {
                    this.filter.registerDate.end = value
                }
                this.filter.registerDate.start = value
            },
            onRegisterEndDate: function(value){
                var vm = this
                if (moment(value).isBefore(this.filter.registerDate.start)) {
                    this.filter.registerDate.start = value
                }
                this.filter.registerDate.end = value
            },
            reset: function(){

            },
            onOptionChange: function(option){
                this.type = option
                // this.saveWelcomeMessage()
            },
            onDeleteGeneric: function(index){
                if (this.generics.length > 1 ) {
                    
                    this.generics.splice(index,1)
                } else {
                    alert("Generic Message cannot be less than 1")
                }
            },
            onMove: function(index, direction){
                var vm = this
                if (direction == 'left') {
                    vm.generics.splice(index, 0, vm.generics.splice(index-1, 1)[0]);
                } else if(direction == 'right') {
                    vm.generics.splice(index, 0, vm.generics.splice(index+1, 1)[0]);
                }
            },
            addGeneric: function(){
                if (this.generics.length < 10) {
                    
                    this.generics.push(
                    {
                        image_url: null,
                        title: '',
                        subtitle: '',
                        buttons: [],
        
                        enable: true
                    })
                }
            },
            onBack: function(){
                var vm = this
                vm.$emit('onClose')
            },
            onSave: function(){
                var vm = this
                vm.$validator.validateAll().then(result => {
					if (!result) {
                        // do stuff if not valid.
                        vm.goToErrorInput()
                        
						return false
                    }
                    // if (vm.groupType == 'customize' && vm.$store.getters.getPackage != 'premium') {
                    //     vm.showUpgrade = true
                    //     return false
                    // }
                    vm.$store.dispatch('loading')
                    vm.updateBroadcast(false,function(status){
                        if (status) {
                            vm.isSave = true
                        } else {
                            vm.isFail = true
                        }
                        $("html, body").animate({ scrollTop: 0 });
                        
                        vm.$store.dispatch('loading')
                    })

                })
            },
            onSend: function(){
                var vm = this
                
                vm.$validator.validateAll().then(result => {
					if (!result) {
                        // do stuff if not valid.
                        vm.goToErrorInput()
						return false
                    }
                    if (vm.groupType == 'customize' && vm.$store.getters.getPackage != 'premium') {
                        vm.showUpgrade = true
                        return false
                    }
                    if (confirm("Do you want to broadcast \""+ vm.name +"\"?")) {
                        vm.$store.dispatch('loading')
                        vm.updateBroadcast(true,function(status){
                            if (status) {
                                vm.isSave = true
                                vm.$emit('onClose',vm.name)
                            } else {
                                vm.isFail = true
                                $("html, body").animate({ scrollTop: 0 });
                            }
                            vm.$store.dispatch('loading')
                        })
                    }

                    
                })
            },
            updateBroadcast: function(isSend,callback){
                var vm = this
                var data = {
                    pageid: vm.selectedBot.pageid,
                    name: vm.name,
                    m_val: vm.message,
                    m_type: vm.type,
                    m_quick_reply: '',
                    m_condition: '',
                    sendflag: isSend,
                    page_access_token: vm.selectedBot.page_access_token,
                    pushtype: vm.pushtype,
                    sendtype: vm.sendtype
                }
                if (vm.groupType == 'male') {
                    data.m_condition = 'gender=male'
                } else if(vm.groupType == 'female'){
                    data.m_condition = 'gender=female'
                } else if(vm.groupType == 'customize') {
                    data.filter = vm.filter
                }

                if (vm.broadcast && vm.broadcast.id) {
                    data.broadcastid = vm.broadcast.id
                }

                if(data.m_type == 'template'){
                    data.m_val = JSON.stringify(vm.generics)
                } 

                vm.$emit('onSave',{
                    data: data,
                    onSave: function(status,broadcastid){
                        if (status) {
                            if (broadcastid) {
                                data.id = broadcastid
                            }
                            vm.broadcast = data
                            vm.cached_broadcast = Object.assign({},vm.broadcast)
                        }
                        callback(status)
                    }
                })

            },
            estimateReach: function(type){
                var vm = this
                var data = {
                    pageid: vm.selectedBot.pageid,
                }
                if (type == 'customize') {
                    data.filter = vm.filter
                } else {
                    if (type == 'male') {
                        data.condition = "&gender=male"
                    } else if(type == 'female') {
                        data.condition = "&gender=female"
                    } else {
                        data.condition = "&gender=all"
                    }
                }
                vm.loadingEstimate = true
                api.estimateReach(data,function(error, response){
                    if (error) {
                        console.error(error)
                        vm.loadingEstimate = false
                        return
                    }
                    if (response.data) { 
                        vm.estimate_user = response.data.count
                    } else {
                        vm.estimate_user = 0
                    }
                    vm.$nextTick(function(){
                        vm.loadingEstimate = false
                    })
                })
            },
            onSelectGroupType: function(type){
                
                if (type.value == 'customize') {
                    if (this.$store.getters.getPackage == 'premium') {                        
                        this.estimateReach(type.value)      
                    } else {
                        this.estimateReach('')   
                    }
                } else {
                    this.estimateReach(type.value)
                }
            }
        },
        watch: {
            value: function(newVal, oldVal){
                // console.log('update',newVal)
            },
            filter: {
                handler: function(newValue) {
                    if (this.groupType == 'customize' && this.$store.getters.getPackage == 'premium') {
                        this.estimateReach(this.groupType)
                    }
                },
                deep: true
            },
            groupType: function(){
                
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/view/broadcast/BroadcastManage.vue